import { createContext, useContext } from 'react';
import hyperspaceLight from '@sprinklr/spaceweb-themes/hyperspace/light';
export var themeContext = createContext(hyperspaceLight);
export var useTheme = function () { return useContext(themeContext); };
export var ThemeConsumer = themeContext.Consumer;
